import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    Select,
    MenuItem,
    SelectChangeEvent,
    FormControl,
    InputLabel,
} from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function APIKeys({ open, onClose, setOpen }: ModalProps) {
    const [carrier, setCarrier] = useState("");
    const [environment, setEnvironment] = useState("");
    const [credType, setCredType] = useState("API Key");
    const [apiKey, setApiKey] = useState("");
    const [apiSecret, setApiSecret] = useState("");
    const [accountId, setAccountId] = useState("");

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">
                    {/* Header */}
                    <div className="modal_title">
                        <h2>Add API Credentials</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">

                            {/* Carrier */}
                            <div className="control_group">
                                <label htmlFor="api-carrier">Carrier</label>
                                <FormControl fullWidth>
                                    <Select
                                        value={carrier}
                                        onChange={(e: SelectChangeEvent) =>
                                            setCarrier(e.target.value)
                                        }
                                        inputProps={{ id: "api-carrier" }}
                                    >
                                        <MenuItem value="Aramex">Aramex</MenuItem>
                                        <MenuItem value="DHL Express">
                                            DHL Express
                                        </MenuItem>
                                        <MenuItem value="FedEx">FedEx</MenuItem>
                                        <MenuItem value="Fetchr">Fetchr</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>

                            {/* Environment */}
                            <div className="control_group w_50">
                                <label htmlFor="api-environment">Environment</label>
                                <FormControl fullWidth>
                                    <Select
                                        value={environment}
                                        onChange={(e: SelectChangeEvent) =>
                                            setEnvironment(e.target.value)
                                        }
                                        inputProps={{ id: "api-environment" }}
                                    >
                                        <MenuItem value="Sandbox">Sandbox</MenuItem>
                                        <MenuItem value="Production">
                                            Production
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </div>

                            {/* Credential Type */}
                            <div className="control_group w_50">
                                <label htmlFor="api-cred-type">Credential Type</label>
                                <FormControl fullWidth>
                                    <Select
                                        value={credType}
                                        onChange={(e: SelectChangeEvent) =>
                                            setCredType(e.target.value)
                                        }
                                        inputProps={{ id: "api-cred-type" }}
                                    >
                                        <MenuItem value="API Key">
                                            API Key
                                        </MenuItem>
                                        <MenuItem value="OAuth">
                                            OAuth
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </div>

                            {/* API Key */}
                            <div className="control_group">
                                <label htmlFor="api-key">API Key</label>
                                <TextField
                                    placeholder="sk_test_..."
                                    fullWidth
                                    hiddenLabel
                                    value={apiKey}
                                    onChange={(e) => setApiKey(e.target.value)}
                                    inputProps={{ id: "api-key" }}
                                />
                            </div>

                            {/* API Secret */}
                            <div className="control_group">
                                <label htmlFor="api-secret">API Secret</label>
                                <TextField
                                    placeholder="Enter API secret..."
                                    fullWidth
                                    hiddenLabel
                                    value={apiSecret}
                                    onChange={(e) =>
                                        setApiSecret(e.target.value)
                                    }
                                    inputProps={{ id: "api-secret" }}
                                />
                            </div>

                            {/* Account ID */}
                            <div className="control_group">
                                <label htmlFor="api-account-id">Account ID</label>
                                <TextField
                                    placeholder="ACC123456"
                                    fullWidth
                                    hiddenLabel
                                    value={accountId}
                                    onChange={(e) =>
                                        setAccountId(e.target.value)
                                    }
                                    inputProps={{ id: "api-account-id" }}
                                />
                            </div>

                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn btn_primary"
                                onClick={() => {
                                    // save logic
                                    setOpen(false);
                                }}
                            >
                                Save
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
